module.exports = __webpack_public_path__ + "static/media/0242_Medium.150473ff.jpg";